module.exports = __webpack_public_path__ + "static/6319-352b98b28c86543a2d05d67a6b04b2dc.png";